import { createSlice } from '@reduxjs/toolkit';
import { fetchFormSubmissionByAddress } from './actions';

const initialState = {
  hasErrors: false,
  loading: false,
  formSubmissionsMap: {},
};

const formSubmissionsSlice = createSlice({
  name: 'formSubmissions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Async agent fetch
    builder.addCase(fetchFormSubmissionByAddress.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      fetchFormSubmissionByAddress.fulfilled,
      (state, { meta, payload }) => {
        state.formSubmissionsMap[meta.arg] = { ...payload, id: meta.arg };
        state.loading = false;
        state.hasErrors = false;
      },
    );
    builder.addCase(fetchFormSubmissionByAddress.rejected, (state) => {
      state.loading = false;
      state.hasErrors = true; // TODO: add errors
    });
  },
});

// Reducer
export default formSubmissionsSlice.reducer;
